import { MouseEvent, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { Button, Icon } from '@mercator-gcp/grout';
import PopoverMenu from 'components/elements/PopoverMenu';
import { CompanyLead } from 'types';

const triggerButtonStyle = {
  height: 'auto',
  justifyContent: 'center',
};

type CompanyRowMenuProps = {
  company: CompanyLead;
  onRemoveFromGroup: (company: CompanyLead) => void;
};

const RowMenuCell = ({ company, onRemoveFromGroup }: CompanyRowMenuProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const onClose = () => setIsMenuOpen(false);

  const onClickMenu = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMenuOpen((prev) => !prev);
  };

  const handleRemoveFromGroup = () => {
    onRemoveFromGroup(company);
    onClose();
  };

  return (
    <PopoverMenu isOpen={isMenuOpen} onClose={onClose}>
      <PopoverMenu.Trigger>
        <Box>
          <Button
            variant="unstyled"
            onClick={onClickMenu}
            sx={triggerButtonStyle}
            aria-label="company row menu"
          >
            <Icon name={Icon.Name.KebabMenu} />
          </Button>
        </Box>
      </PopoverMenu.Trigger>
      <PopoverMenu.Content>
        <PopoverMenu.Item
          iconName={Icon.Name.CloseX}
          onClick={handleRemoveFromGroup}
          label="Remove from Group"
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  );
};

export default RowMenuCell;
